<template>
    <v-dialog v-model="showDialog_DutyFlags" width="650" persistent>
        <v-card>
            <v-card-title class="blue-grey pa-5" style="color: white; font-size: 15px;  font-weight: 500;">
                <i style="font-size:20px;" class="b-fa b-fa-chess-queen"></i>&nbsp;&nbsp;Select/Modify DutyFlag(s) on Flight
            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <!-- >>> OnDty  -------------------------------- -->
                            <p class="" style="font-size:13px; font-weight: 500;">OnDuty (Cockpit: Left Seat, Cabin: SCCM):</p>
                            <v-select
                                v-model="onduty"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="OnDuty (Cockpit: Left Seat, Cabin: SCCM):"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>

                            <!-- >>> TakeOff/Landing  ---------------------- -->
                            <p class="" style="font-size:13px; font-weight: 500;">TakeOff/Landing:</p>
                            <v-select
                                v-model="takeoff"
                                :items="get_flights_CrewDetails_Reduced_Filtered"
                                item-text="filterableName"
                                item-value="idResource"
                                label="TakeOff/Landing:"
                                outlined
                                dense
                                chips
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onCancel_DutyFlags">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_DutyFlags">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';


    export default {
        name : 'Dialog_DutyFlags',

        /* >>> *************************************************************** / /* Props */
        props : {
            value : [ Boolean, Object ], // showDialog_DutyFlags
        },
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
            * watch::get_flights_CrewDetails_Reduced
            *
            * Desc: Monitor/Watch ... 'get_flights_CrewDetails_Reduced'.
            * Note:
            *
            */
            get_flights_CrewDetails_Reduced(v) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_DutyFlags.vue >>> get_flights_CrewDetails_Reduced watch');
                this.get_flights_CrewDetails_Reduced_Filtered = [];
                this.takeoff = { idResource: 0, filterableName: 'John Doe' }; // reset?
                this.onduty = []; // reset?


                // >>> Prefill/Preset -------------------------
                this.get_flights_CrewDetails_Reduced.forEach(member => {
                    // >>> Prefill - TakeOFf/Landing ------
                    if (member.position === 'CP' || member.position === 'FO') {
                        this.get_flights_CrewDetails_Reduced_Filtered.push(member);
                    }


                    // >>> Preset2 ------------------------
                    if (member.onDuty === true) {
                        if (!this.onduty.includes(member.idResource)) {
                            this.onduty.push(member.idResource);
                        }
                    }


                    // >>> Preset3 ------------------------ (is no Array)
                    if (member.takeoff === true) {
                        this.takeoff = { idResource: member.idResource, filterableName: member.filterableName }
                    }
                });

            }, // eo function get_flights_CrewDetails_SavedPayload()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_Reduced',
                'get_flights_CrewDetails_SavedPayload', // getting 'idFlightGroup'
                'get_flights_CrewDetails_Department',
            ]),


            /*******************************************************************
            * showDialog_DutyFlags()
            *
            * Desc:
            * Note:
            *
            */
            showDialog_DutyFlags: {

                /***************************************************************
                * get()
                *
                * Note:.
                *
                */
                get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_DutyFlags.vue >>> showDialog_DutyFlags get');
                    // return always Boolean
                    return !!this.value;

                }, // eo showDialog_DutyFlags get()


                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_DutyFlags.vue >>> showDialog_DutyFlags set');
                    this.$emit('input', value);

                } // eo showDialog_DutyFlags set()

            } // eo function showDialog_DutyFlags()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                get_flights_CrewDetails_Reduced_Filtered: [],
                // >>> --------------------------
                onduty: [],
                takeoff: { idResource: 0, filterableName: 'John Doe' },
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_crews_setDutyFlags',
                'actn_call_crews_setFlightRoles',
                'actn_call_getCrewDetailsFromFlight_Reduced'
            ]),


            /******************************************************************* Part 1
            * onSave_DutyFlags()
            *
            * Desc: Protect & 'DutyFlag' Call(s).
            * Note:
            *
            */
            onSave_DutyFlags: function() {

                let me = this,
                    onDutyWrong = false,
                    tmpDepartment1 = null,
                    tmpDepartment2 = null,
                    paramsDutyFlags = {
                        "cockpitSeatSide": null,
                        "idFlight": null,
                        "idResource": null,
                        "onDuty": false,
                        "takeoff": false,
                        "landing": false
                    },
                    dutyFlags =  [],
                    idFlight = this.get_flights_CrewDetails_SavedPayload.idFlight,
                    get_flights_CrewDetails_Reduced_Copy = [...this.get_flights_CrewDetails_Reduced];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_DutyFlags.vue >>> onSave_DutyFlags');
                // >>> ------------------------------------ 1. Protector(s) #570
                if (this.onduty.length > 0) {
                    if (this.onduty.length > 2) {
                        onDutyWrong = true; // 2 members max
                    }

                    if (!onDutyWrong && this.onduty.length === 2) {
                         tmpDepartment1 = this.get_flights_CrewDetails_Department(this.onduty[0])
                         tmpDepartment2 = this.get_flights_CrewDetails_Department(this.onduty[1])
                         if (tmpDepartment1 === tmpDepartment2) {
                            onDutyWrong = true; // same department
                         }
                    }


                    if (onDutyWrong) {
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Attention: Dear User, onduty only with one-time Cockkpit and Cabin. 2 Members Max.'
                        });
                        return;
                    }
                }


                // >>> ------------------------------------ 2. Duty Flags
                Vue.prototype.$vp_m();
                get_flights_CrewDetails_Reduced_Copy.forEach(member => {
                    paramsDutyFlags = {
                        "cockpitSeatSide": null,
                        "idFlight": idFlight,
                        "idResource": member.idResource,
                        "onDuty": this.onduty.includes(member.idResource) ?  true : false,
                        "takeoff": this.takeoff && this.takeoff === member.idResource ?  true : false,
                        "landing": this.takeoff && this.takeoff === member.idResource ?  true : false
                    };

                    dutyFlags.push(paramsDutyFlags);
                });

                this.actn_call_crews_setDutyFlags({ dutyflags:  dutyFlags });


                // >>> ------------------------------------ Close/Reset/Reload
                setTimeout(() => {
                    Vue.prototype.$vp_um();
                    this.showDialog_DutyFlags = false;
                    this.actn_call_getCrewDetailsFromFlight_Reduced({ idFlight: this.get_flights_CrewDetails_SavedPayload.idFlightGroup });
                }, 700);

            }, // eo function onSave_DutyFlags()


            /*******************************************************************
            * onCancel_DutyFlags()
            *
            * Desc:
            * Note:
            *
            */
            onCancel_DutyFlags: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_DutyFlags.vue >>> onCancel_DutyFlags');
                this.showDialog_DutyFlags = false; // close


                this.onduty = [];
                this.takeoff = { idResource: 0, filterableName: 'John Doe' };

                // >>> Prefill/Preset -------------------------
                this.get_flights_CrewDetails_Reduced.forEach(member => {
                    // >>> Prefill - TakeOFf/Landing ------
                    if (member.position === 'CP' || member.position === 'FO') {
                        this.get_flights_CrewDetails_Reduced_Filtered.push(member);
                    }


                    // >>> Preset2 ------------------------
                    if (member.onDuty === true) {
                        if (!this.onduty.includes(member.idResource)) {
                            this.onduty.push(member.idResource);
                        }
                    }


                    // >>> Preset3 ------------------------ (is no Array)
                    if (member.takeoff === true) {
                        this.takeoff = { idResource: member.idResource, filterableName: member.filterableName }
                    }
                });

            }, // eo function onCancel_DutyFlags()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-top: 4px !important;
    }
</style>
